<section appReveal class="is-section w-full px-4 sm:px-8" [class.is-icon-right]="iconSide === 'right'">
    <div class="is-grid mx-auto grid w-full max-w-[1200px] items-center gap-8 lg:grid-cols-2 lg:gap-16">
        <div class="is-icon-wrap flex justify-center"
            [class.r-left]="iconSide === 'left'" [class.r-right]="iconSide === 'right'">
            <img class="is-icon" [src]="icon" alt="" aria-hidden="true" loading="lazy" />
        </div>
        <div class="is-text"
            [class.r-right]="iconSide === 'left'" [class.r-left]="iconSide === 'right'">
            <h2 class="is-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
            @if (paragraphs.length) {
                <div class="is-prose font-inter space-y-4 mt-5">
                    @for (paragraph of paragraphs; track $index) {
                        <p>{{ paragraph }}</p>
                    }
                </div>
            }
        </div>
    </div>
</section>
